import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintDashboard } from '.';

/**
 * @component {kat-blueprint-dashboard-focus} KatBlueprintDashboardFocus Component used to place and filter components within the focus section.
 * @slot default Blueprint content for focus section.
 */
@register(KatBlueprintDashboard.slotMapping.focus.name)
export class KatBlueprintDashboardFocus extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintDashboard.slotMapping.focus.name,
      KatBlueprintDashboard.slotMapping.focus.allowed
    );
  }
}
